<div class="bulk-confirm">
  <h5 class="block mb-3">{{ heading() }}</h5>

  <ul class="name-list mb-3">
    @for (name of names(); track $index) {
      <li>{{ name }}</li>
    }
  </ul>

  @if (reasonLabel()) {
    <div class="col-12 p-0 mb-1">
      <p class="m-0 text-xsm text-black-alpha font-bold">{{ reasonLabel() }}:</p>
    </div>
    <div class="col-12 mb-3 p-0">
      <textarea rows="3" maxlength="200" cols="30" pInputTextarea [autoResize]="true"
        [placeholder]="reasonPlaceholder()"
        [ngModel]="reason()" (ngModelChange)="reason.set($event)"
        id="bulk-reason" autocomplete="off"></textarea>
    </div>
  }

  <div class="flex justify-content-end gap-2">
    <p-button label="cancel" [outlined]="true" [text]="true" (onClick)="cancel()" />
    <p-button [label]="confirmLabel()" [severity]="confirmSeverity()" (onClick)="confirm()" />
  </div>
</div>
